import React, { useMemo } from 'react';

import * as S from './styles';

const createQuantityOptions = (num: number) => {
  const acc = [];
  for (let i = 1; i <= num; i++) {
    acc.push({ value: i.toString(), id: i.toString() });
  }
  return acc;
};

type QuantityPickerProps = {
  onQuantityPickerChange: (e: React.FormEvent<HTMLInputElement>) => void;
  className?: string;
  numOfOptions?: number;
  selectedOption?: number;
};

export const QuantityPicker: React.FunctionComponent<QuantityPickerProps> = ({
  onQuantityPickerChange,
  className,
  numOfOptions = 9,
  selectedOption,
}: QuantityPickerProps) => {
  const quantityOptions = useMemo(
    () => createQuantityOptions(numOfOptions),
    [],
  );
  return (
    <S.QtyDropdown
      id="productQuantityPicker"
      items={quantityOptions}
      label="product quantity"
      name="productQuantity"
      onChange={onQuantityPickerChange}
      className={className}
      data-testid="productQuantityPicker"
      hideLabel
      value={`${selectedOption}`}
    />
  );
};

export default QuantityPicker;
